// extracted by mini-css-extract-plugin
export default {"container":"BarChart_container__VE1RS"};